export default __webpack_public_path__ + "static/media/rokdim-logo.6160e6bd.png";